import { FormField, Pagination, Table, TextFilter } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, getUser, sanitizeKeyw, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import SelectPaging from '../../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';

const pageSize = 20;

export const AdminCasinoStatementsDailyPage = () => {
  //const storeAdmin = useStoreAdmin();

  const { menu, parameters, data } = useGlobalState();
  const { navigate } = useRouter();


  const [movements, setMovements] = useState<any[]>([]);
  const [filteringText, setFilteringText] = useState('');
  const [currentPageIndex, setCurrentPageIndex] = useState(1);


  const filtered = movements.filter((movement: any) => {
    const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);

    return searchWords.every(word =>
      sanitizeKeyw(movement.displayName ?? "").includes(word) ||
      sanitizeKeyw(movement.ammount?.toString() ?? "").includes(word) ||
      sanitizeKeyw(movement.tipo ?? "").includes(word)
    );
  });
  const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);



  useEffect(() => {
    setMovements([]);
    handleRefreshMovements();
  }, [parameters?.date]); //parameters.startDate, parameters.endDate, 




  const handleRefreshMovements = async () => {
    //if (parameters.startDate && parameters.endDate) { 
    if (parameters.month && parameters.year) {

      try {
        setLoading(true)
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/movements/casino/list',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify(
            {
              limit: 1000,
              ammount: -1,
              orderBy: "dateMovement",
              order: "desc",
              date: parameters.date,
            }
          ),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const dataWeb = await response.json();
        if (dataWeb.code == 0) {
          setMovements(dataWeb.movements.map((m: any) => ({
            ...m,
            displayName: m.idUser > 0 ? getUser(m.idUser, data)?.displayName : ""
          })))
        } else {
          addNotification(dataWeb.status, 'error', setData);
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }
  return (
    <CustomAppLayout
      toolsHide

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween direction="vertical" size="xs">

            <Header
              description={<>Listado de movimientos de la cuenta casino para pagos realizados en una fecha en particular</>}
              actions={
                <SpaceBetween direction="horizontal" size="xs">

                  <Favorites />
                </SpaceBetween>
              }
            >
              Cartola cuenta casino
            </Header>

            <Table
              pagination={

                <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                  {movements.length > parameters.pageSize && (
                    <Pagination
                      currentPageIndex={currentPageIndex}
                      pagesCount={Math.ceil(movements.length / parameters.pageSize)}
                      onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                    />
                  )}

                  {movements.length > 0 && movements.length > parameters.pageSize && (
                    <SelectPaging onSelect={(pageSize) => {
                      setCurrentPageIndex(1);
                      setParameters({ ...parameters, pageSize: pageSize });
                    }} />
                  )}
                </SpaceBetween>
              }
              filter={
                <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                  <div style={{ width: 100 }}>
                    <DPModal date={parameters.date} onConfirm={(date) => {
                      setParameters({ ...parameters, date: date });
                    }}
                      end={new Date()}
                    />
                  </div>
                  <TextFilter filteringText={filteringText} onChange={(e) => setFilteringText(e.detail.filteringText)} />


                </SpaceBetween>
              }
              cellVerticalAlign='top'
              stickyHeader
              variant="embedded"
              columnDefinitions={[
                {
                  id: "dateTransaction",
                  header: "Fecha",
                  width: 120,
                  cell: item => <FormField label={item.dateMovement}>{item.timeMovement}</FormField>
                },
                {
                  id: "data",
                  header: "Glosa",
                  cell: item => <FormField label={item.idUser > 0 ? getUser(item.idUser, data)?.displayName : ""} >{item.ammount > 0 ? "Abono Cta Casino desde Cta CPV" : "Pago Cta Socio a Casino"}</FormField>
                },
                {
                  id: "exp",
                  header: "Expiración",
                  cell: item => (
                    <FormField label={item.ammount > 0 ? item.dateExpires : ""}>
                      {item.ammount > 0 && item.isExpired === 0 ?
                        `Saldo: ${formatCurrency(item.balanceNonExpired, "CLP")}` : ""}
                    </FormField>

                  )
                },
                {
                  id: "ammount",
                  header: "Monto",
                  cell: item => item.ammount.toLocaleString('es-CL', {
                    style: 'currency',
                    currency: 'CLP',
                    maximumFractionDigits: 0
                  }),
                },
              ]}
              items={paginated}
            />
          </SpaceBetween>
        </>
      }
    />
  );
};
